//javascript,react libraries
import { useEffect, useContext, useState } from "react";
//app data
import { UserContext } from "../../../model/contexts/user.context";

//components
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import ProjectDashboard from "../../components/ProjectDashboard/ProjectDashboard";
import SignIn from "../../components/SignIn/SignIn";

//styling
import "./ProjectDashboardPage.scss";

const ProjectDashboardPage = () => {
  const { currentUser, setCurrentUser } = useContext(UserContext);

  return (
    <div className="dashboard-container-context">
      <ProjectDashboard />
    </div>
  );
};

export default ProjectDashboardPage;

//include the form modal when project is selected using edit button**
//prioritize by number of tasks, recently updated, date created, project importance, etc.
